import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewSingleUser = (id) => {
  return useQuery({
    queryKey: ["user", id],
    queryFn: async () => {
      const res = await api.get(`/user/${id}`);
      return res.data;
    },
    enabled: !!id, // prevents unnecessary call
  });
};